/**
 * Configuration settings for the application
 */

// Determine the environment
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = process.env.NODE_ENV === 'development' || !process.env.NODE_ENV;

// Default API URL from the environment or fallback
const DEFAULT_API_URL = process.env.REACT_APP_API_URL || 'https://taskmangerback-t2b1.vercel.app';

// Helper function to get OpenAI API key from various sources
const getOpenAIKey = () => {
  // Try to get from React environment variables
  if (process.env.REACT_APP_OPENAI_API_KEY) {
    return process.env.REACT_APP_OPENAI_API_KEY;
  }
  
  // Try to get from window global variables (might be set by script tags)
  if (typeof window !== 'undefined' && window.OPENAI_API_KEY) {
    return window.OPENAI_API_KEY;
  }
  
  // Try alternative environment variables that might be set in production
  if (process.env.OPENAI_API_KEY) {
    return process.env.OPENAI_API_KEY;
  }
  
  // Return empty string if no key found
  return '';
};

// Configuration object
const config = {
  app: {
    name: 'Task Manager',
    version: '1.0.0',
  },
  api: {
    // Use the configured API URL or fallback
    baseUrl: DEFAULT_API_URL,
    timeout: 30000, // 30 seconds
  },
  auth: {
    // Clerk authentication settings
    clerkPublishableKey: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '',
  },
  openai: {
    // OpenAI API settings
    apiKey: getOpenAIKey(),
    model: 'gpt-4o',
  },
  features: {
    speechToText: true,
    darkMode: false,
    // Feature flags for different functionalities
    enableDragAndDrop: true,
  },
  debug: isDevelopment,
};

export default config; 